export default __webpack_public_path__ + "static/media/logo.0bca1d7c.png";